import axios from "axios";
import axiosRetry from "axios-retry";

axios.defaults.withCredentials = true;
const http = axios.create({withCredentials: true});
axiosRetry(http, { retries: 10 });

export default http;